import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/benefits-for-producers/page.tsx")